import React from 'react';
import { IonIcon } from '@ionic/react';

type IonColor = 'primary' | 'danger';

export const PRO_SECTION_HEADER_ROW_CLASS =
  'flex items-center justify-between px-4 pt-4 pb-1 min-h-[30px]';
export const PRO_SECTION_HEADER_LABEL_CLASS =
  'm-0 p-0 text-xs font-semibold uppercase tracking-wider leading-none text-text-tertiary dark:text-text-dark-tertiary';
export const PRO_SECTION_HEADER_ACTIONS_CLASS =
  'flex items-center -mr-3 [&_ion-button]:m-0 [&_ion-button]:h-[30px] [&_ion-button]:min-h-[30px] [&_ion-button]:[--padding-top:0] [&_ion-button]:[--padding-bottom:0] [&_ion-button]:[--min-height:30px]';

export const PRO_SECTION_HEADER_BUTTON_PROPS = {
  fill: 'clear' as const,
  size: 'small' as const,
  className: 'text-xs m-0 h-[30px]',
};

export interface ProSectionHeaderProps {
  title: string;
  icon: string;
  iconColor?: IonColor;
  right?: React.ReactNode;
}

/**
 * Uppercase section eyebrow used on Pro Home and account screens.
 * Sits above a card in `px-2`; optional trailing actions on the right.
 */
const ProSectionHeader: React.FC<ProSectionHeaderProps> = ({
  title,
  icon,
  iconColor = 'primary',
  right,
}) => (
  <div className={PRO_SECTION_HEADER_ROW_CLASS}>
    <div className="flex items-center gap-1.5">
      <IonIcon icon={icon} color={iconColor} className="text-xs shrink-0" />
      <h2 className={PRO_SECTION_HEADER_LABEL_CLASS}>{title}</h2>
    </div>
    {right && <div className={PRO_SECTION_HEADER_ACTIONS_CLASS}>{right}</div>}
  </div>
);

export default ProSectionHeader;
